import {Pipe, PipeTransform} from "@angular/core";

@Pipe({ name: 'split' })
export class SplitPipe implements PipeTransform {
  transform(value: string , character: string = '') {
    return value.split(character);
  }
}
